// Store the manifest version at module level to persist across navigation
let cachedManifestVersion: string | null = null;

export function useManifestVersion(): { browserManifestVersion: string; isNewerThan: (version: string) => boolean } {
  if (cachedManifestVersion === null) {
    const { search } = window.location;
    cachedManifestVersion = new URLSearchParams(search).get("version") ?? "0.0";
  }

  const browserManifestVersion = cachedManifestVersion;
  const isNewerThan = (version: string): boolean => isGreaterThanCompareVersion(version, browserManifestVersion);

  return { browserManifestVersion, isNewerThan };
}

// Checks if the current version is greater than the comparison version
const isGreaterThanCompareVersion = (comparisonVersion: string, currentVersion: string): boolean => {
  const compareParts = comparisonVersion.split(".").map(Number);
  const currentParts = currentVersion.split(".").map(Number);

  for (let i = 0; i < 3; i++) {
    const compareValue = compareParts[i] ?? 0;
    const currentValue = currentParts[i] ?? 0;

    if (currentValue > compareValue) {
      return true;
    }
    if (currentValue < compareValue) {
      return false;
    }
  }

  return false; // Versions equal
};
